<i18n>
{
  "fr": {
    "getQuotation": {
      "adminButtonLabel": "Envoyer le projet par mail",
      "authModalTitle": "Connectez-vous pour recevoir votre projet par mail",
      "customerButtonLabel": "Recevoir mon projet par mail"
    }
  }
}
</i18n>

<script>
import AuthModal from '../Modals/AuthModal.vue';
import GetQuotationModal from './GetQuotationModal.vue';

export default {
  name: 'GetQuotation',
  components: { AuthModal, GetQuotationModal },
  props: {
    authIframeUrl: {
      type: String,
      default: null,
    },
    authModalTitle: {
      type: String,
      default: null,
    },
    buttonClasses: {
      type: Array,
      required: true,
    },
    isAdmin: Boolean,
    isCustomer: Boolean,
    url: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      needsAuthModal: false,
    };
  },
  methods: {
    showGetQuotationModal() {
      window.modalStateObservable.isGetQuotationModalActive = true;
    },
    authCallback() {
      window.top.location = this.url;
    },
    showAuthModal() {
      this.needsAuthModal = true;
      window.modalStateObservable.isAuthModalActive = true;
    },
  },
};
</script>

<template>
  <div class="get-quotation">
    <template v-if="isCustomer">
      <a :href="url" :class="buttonClasses">
        <i class="icon icon--arrow-left1 get-quotation__icon"></i>
        {{ $t('getQuotation.customerButtonLabel') }}
      </a>
    </template>

    <template v-else-if="isAdmin">
      <GetQuotationModal :submit-url="url" />
      <button
        type="button"
        :class="buttonClasses"
        @click="showGetQuotationModal"
      >
        <i class="icon icon--arrow-left1 get-quotation__icon"></i>
        <span>{{ $t('getQuotation.adminButtonLabel') }}</span>
      </button>
    </template>

    <template v-else>
      <AuthModal
        v-if="needsAuthModal"
        :callback="authCallback"
        :iframe-url="authIframeUrl"
        :title="$t('getQuotation.authModalTitle')"
      />
      <button type="button" :class="buttonClasses" @click="showAuthModal">
        <i class="icon icon--arrow-left1 get-quotation__icon"></i>
        <span>{{ $t('getQuotation.customerButtonLabel') }}</span>
      </button>
    </template>
  </div>
</template>

<style lang="scss">
.get-quotation {
  .checkout-process-cart__button {
    width: 100%;
  }

  &__icon {
    margin-right: 0.5em;
  }
}
</style>
